import { css } from "@emotion/css";
import type { IconProps } from "@octopusdeploy/design-system-icons";
import { borderWidth, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { AvatarProps } from "../../Avatar";
import { SelectOptionLayout } from "./SelectOptionLayout";
export interface SelectOption {
    label: string;
    value: string;
    description?: string;
    prefix?: React.ReactElement<IconProps> | React.ReactElement<AvatarProps>;
}
export interface SelectOptionProps {
    option: SelectOption;
    selected: boolean;
}
export function SelectOption({ option, selected }: SelectOptionProps) {
    return <SelectOptionLayout label={option.label} description={option.description} prefix={option.prefix} className={selected ? selectedOptionStyles : selectOptionStyles}/>;
}
const selectOptionStyles = css({
    borderLeft: `${borderWidth[4]} solid transparent`,
});
const selectedOptionStyles = css({
    backgroundColor: themeTokens.color.menuList.background.hover,
    borderLeft: `${borderWidth[4]} solid ${themeTokens.color.border.selected}`,
});
